import React from "react";

export default function HealthPage () {
    return (
        <>OK</>
    );
}
